import instance from "../../../api";

const qrAnalyticsApi = {
    getQrAnalytics: async (branchId, dates = '') => {
        return await instance().get(`/analytics/branches/${branchId}/qr${dates}`)
            .then(res => res.data.data)
    },
}

export default qrAnalyticsApi;
